import { useState } from 'react'
import { UserPlus, Mail, User, Building2, Briefcase, Phone, MapPin, Tag } from 'lucide-react'
import api from '../../services/api'
import { showSuccess, showError, showInfo } from '../../utils/toast'
import Modal from '../ui/Modal'
import Button from '../ui/Button'
import { Input, Label, FormGroup } from '../ui/Input'
import './AddContactModal.css'

export default function AddContactModal({ isOpen, onClose, onContactAdded }) {
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    company: '',
    jobTitle: '',
    phone: '',
    country: '',
    seniority: '',
    industry: '',
    department: '',
    isContact: true
  })
  const [saving, setSaving] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!formData.email || !formData.email.includes('@')) {
      showError('Email valide requis')
      return
    }

    setSaving(true)

    try {
      const response = await api.post('/api/prospects/create-manual', formData)
      
      if (response.data.alreadyExists) {
        showInfo('Ce contact existe déjà dans votre liste')
      } else if (response.data.wasLinked) {
        showSuccess('Contact ajouté à votre liste !')
      } else {
        showSuccess('Contact créé !')
      }
      
      onContactAdded?.()
      handleClose()
    } catch (error) {
      showError(error.response?.data?.error || 'Erreur')
      setSaving(false)
    }
  }

  const handleClose = () => {
    setFormData({
      email: '',
      firstName: '',
      lastName: '',
      company: '',
      jobTitle: '',
      phone: '',
      country: '',
      seniority: '',
      industry: '',
      department: '',
      isContact: true
    })
    setSaving(false)
    onClose()
  }

  const footer = (
    <>
      <Button variant="secondary" onClick={handleClose} disabled={saving}>
        Annuler
      </Button>
      <Button 
        type="submit" 
        form="add-contact-form"
        loading={saving} 
        disabled={!formData.email}
      >
        <UserPlus size={16} />
        Créer le contact
      </Button>
    </>
  )

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Ajouter un contact"
      size="lg"
      footer={footer}
    >
      <form id="add-contact-form" onSubmit={handleSubmit} className="add-contact-form">
        {/* Email (required) */}
        <FormGroup>
          <Label required className="label-with-icon">
            <Mail size={16} className="text-primary" />
            Email
          </Label>
          <Input
            type="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="jean.dupont@example.com"
          />
        </FormGroup>

        {/* Prénom & Nom */}
        <div className="form-row">
          <FormGroup>
            <Label className="label-with-icon">
              <User size={16} />
              Prénom
            </Label>
            <Input
              type="text"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              placeholder="Jean"
            />
          </FormGroup>

          <FormGroup>
            <Label className="label-with-icon">
              <User size={16} />
              Nom
            </Label>
            <Input
              type="text"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              placeholder="Dupont"
            />
          </FormGroup>
        </div>

        {/* Entreprise & Poste */}
        <div className="form-row">
          <FormGroup>
            <Label className="label-with-icon">
              <Building2 size={16} />
              Entreprise
            </Label>
            <Input
              type="text"
              value={formData.company}
              onChange={(e) => setFormData({ ...formData, company: e.target.value })}
              placeholder="Acme Inc"
            />
          </FormGroup>

          <FormGroup>
            <Label className="label-with-icon">
              <Briefcase size={16} />
              Poste
            </Label>
            <Input
              type="text"
              value={formData.jobTitle}
              onChange={(e) => setFormData({ ...formData, jobTitle: e.target.value })}
              placeholder="CEO"
            />
          </FormGroup>
        </div>

        {/* Téléphone & Pays */}
        <div className="form-row">
          <FormGroup>
            <Label className="label-with-icon">
              <Phone size={16} />
              Téléphone
            </Label>
            <Input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              placeholder="+33 6 12 34 56 78"
            />
          </FormGroup>

          <FormGroup>
            <Label className="label-with-icon">
              <MapPin size={16} />
              Pays
            </Label>
            <Input
              type="text"
              value={formData.country}
              onChange={(e) => setFormData({ ...formData, country: e.target.value })}
              placeholder="France"
            />
          </FormGroup>
        </div>

        {/* Séniorité & Industrie */}
        <div className="form-row">
          <FormGroup>
            <Label className="label-with-icon">
              <Tag size={16} />
              Séniorité
            </Label>
            <Input
              type="text"
              value={formData.seniority}
              onChange={(e) => setFormData({ ...formData, seniority: e.target.value })}
              placeholder="Senior, Junior..."
            />
          </FormGroup>

          <FormGroup>
            <Label className="label-with-icon">
              <Building2 size={16} />
              Industrie
            </Label>
            <Input
              type="text"
              value={formData.industry}
              onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
              placeholder="Tech, Finance..."
            />
          </FormGroup>
        </div>

        {/* Département */}
        <FormGroup>
          <Label className="label-with-icon">
            <Tag size={16} />
            Département
          </Label>
          <Input
            type="text"
            value={formData.department}
            onChange={(e) => setFormData({ ...formData, department: e.target.value })}
            placeholder="Sales, Engineering..."
          />
        </FormGroup>
      </form>
    </Modal>
  )
}
